import axios from 'axios'
import {Message} from 'element-ui'
import ct from '../utils/constant.js'
import {getStorage} from '../utils/utils.js'
axios.interceptors.request.use(config => {
  return config
}, err => {
  Message.error({message: '请求超时!'})
  return Promise.resolve(err)
})
axios.interceptors.response.use(res => {
  // console.log(res)
  if (res.status && res.status === 200) {
    if (res.data.code === 1 || res.data.code === 101) {
      let msg = res.data.message
      // console.log(msg)
      if (msg.indexOf('会话已过期') > -1) {
        let user = getStorage('user')
        if (user) {
          Message.error({message: msg})
          window.localStorage.clear()
          window.sessionStorage.clear()
        }
        window.app.$router.push(ct.RouterData.login.path)
      } else {
        Message.error({message: msg})
      }
    }
    // let msg = res.data.message
    // if (msg.indexOf('会话已过期') > -1) {
    //   window.app.$router.push(ct.RouterData.login.path)
    //   Message.error({message: msg})
    //   return res
    // }
  }
  return res
}, err => {
  // console.log(err)
  if (err.response) {
    if (err.response.status === 504 || err.response.status === 404) {
      Message.error({message: '服务器被吃了⊙﹏⊙∥'})
    } else if (err.response.status === 403) {
      Message.error({message: '权限不足,请联系管理员!'})
    } else {
      Message.error({message: '未知错误!'})
    }
  }
  return Promise.resolve(err)
})

// let base = '/gcapi/'
// let base = process.env.API + '/gcapi/'
let base = ''
if (process.env.NODE_ENV === 'development') {
  base = '/gcapi/'
} else {
  base = '/cloud/gcapi/'
}

export const postRequest = (url, params) => {
  let param = url.indexOf('gcwwwifc') > -1 ? params : {Json: JSON.stringify(params)}
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: param,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
  })
}
export const uploadFileDo = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
      // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
  })
}

export const uploadFileRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      // 'Content-Type': 'multipart/form-data',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
  })
}

export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`
  })
}
export const getRequest = (url) => {
  return axios({
    method: 'get',
    url: `${base}${url}`
  })
}

let base1 = ''
export const request = (url) => {
  return axios({
    method: 'get',
    url: `${base1}${url}`
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js